export { default as MessageBox } from './MessageBox';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/components/MessageBox/index.js
// module id = 4654
// module chunks = 11